export default __webpack_public_path__ + "static/media/dropin-icon.168695df.svg";